import { NavLink, withRouter } from "react-router-dom";
import OptimisedImage from "../components/optimisedImage";
import React, { Component, Fragment } from "react";
import cx from "classnames";

// import CompaniesSummaryForNav from '../content/companiesSummaryForNav'
import IndustriesSummaryForNav from "../content/industriesSummaryForNav";
import RolesSummaryForNav from "../content/rolesSummaryForNav";

import SignUpBtn from "../components/signup/signup";
import _ from "lodash";
import wflogo from "../assets/images/WF-colored.svg";
import wflogoWhite from "../assets/images/WF-white.svg";

class Navbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      navbarMenuHidden: true,
      hideDropdown: false,
      showBanner: false,
      showCategories: false,
      textWhite: false,
      screenWidth: null,
      email: "",
      activeCountry: "",
      navIsScrolled: false,
      industries: [],
      path: "",
      isNews: false,
    };
    this.catNavUl = React.createRef();
    this.leftScroll = React.createRef();
    this.rightScroll = React.createRef();
    this.scrollableNav = React.createRef();
  }

  componentDidMount() {
    this.setCountry();
    this.updateWindowDimensions();
    this.setNavbarColor();
    this.setIndustries();
    this.handleWFtraffic();
    window.addEventListener("resize", this.updateWindowDimensions);
    if (this.state.activeCountry.code === "uk") {
      localStorage.setItem("CountryCode", JSON.stringify("uk"));
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.screenWidth !== this.state.screenWidth &&
      this.state.screenWidth > 1024
    ) {
      this.removeActiveClass(null, "navbar__item");
      this.removeActiveClass(null, "dropdown__list");
      this.setState({ navbarMenuHidden: true });
    }

    if (this.props.location !== prevProps.location) {
      this.setNavbarColor();
      this.setCountry();
    }
    if (prevState.activeCountry !== this.state.activeCountry) {
      this.setIndustries();
    }
    if (this.state.path !== this.props.history.location.pathname) {
      this.setState({ path: this.props.history.location.pathname });
      this.setState({
        isNews: this.props.history.location.pathname.includes("news"),
      });
    }
  }

  updateWindowDimensions = () => {
    this.setState({ screenWidth: window.innerWidth });
  };

  setCountry = () => {
    const currentLocation = window.location.pathname;
    const firstPath = currentLocation.split("/");

    if (firstPath[1] === "uk") {
      this.setState({
        activeCountry: {
          code: "uk",
          name: "United Kingdom",
          flagImg: "/images/uk-flag.svg",
          phoneText: "+44 333 577 2373",
          phoneNo: "+44 333 577 2373",
        },
      });
    } else {
      this.setState({
        activeCountry: {
          code: "us",
          name: "United States",
          flagImg: "/images/us-flag.svg",
          phoneText: "+1 888 766 5582",
          phoneNo: "+1 888 766 5582",
        },
      });
    }
  };

  handleRemoveCountryCode = () => {
    this.setCountry();
    localStorage.removeItem("CountryCode");
    this.props.history.push("/us");
  };

  setNavbarColor = () => {
    const currentLocation = this.handleEndPath();
    const firstPath = currentLocation.split("/");
    const showBanner = currentLocation.split("/")[1] === "news"; // Banner for News and Article Pages
    const showCategories = !!(
      firstPath[1] === "news" ||
      firstPath[1] === "category" ||
      firstPath[1] === "videos" ||
      firstPath[1] === "tag" ||
      firstPath[1] === "wf-events" ||
      firstPath[1] === "awards" ||
      firstPath[1] === "research" ||
      firstPath[1] === "author"
    );
    const textWhite = !!(
      (firstPath[1] === "industry" &&
        firstPath[3] === undefined &&
        firstPath[2] !== "hospitals" &&
        firstPath[2] !== "call-center" &&
        firstPath[2] !== "restaurant-and-bars" &&
        firstPath[2] !== "restaurant-and-dining") || // New Conditions are for new Industry Pages
      (firstPath[1] === "integrations" && firstPath.length === 2) ||
      firstPath[1] === "workforce-management" ||
      firstPath[1] === "tools" ||
      firstPath[1] === "about" ||
      firstPath[1] === "role" ||
      firstPath[1] === "company" ||
      firstPath[1] === "api" ||
      firstPath[1] === "subscribe"
    );

    this.setState({
      showBanner: showBanner,
      textWhite: textWhite,
      showCategories: showCategories,
    });

    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 20) {
        this.setState({
          textWhite: false && !textWhite,
          navIsScrolled: true,
        });
      } else {
        this.setState({
          textWhite: true && textWhite,
          navIsScrolled: false,
        });
      }
    });
  };

  toggleNavbarMenu = () => {
    this.setState((state) => ({
      navbarMenuHidden: !state.navbarMenuHidden,
    }));
  };

  removeActiveClass = (excludedEl, elClass) => {
    const elArr = document.querySelectorAll("." + elClass);
    let filteredelArr;

    if (excludedEl) {
      filteredelArr = _.filter(elArr, (el) => {
        return el !== excludedEl;
      });
    }

    (excludedEl ? filteredelArr : elArr).forEach((el) => {
      el.className = el.className.replace(/\bactive\b/g, "");
    });
  };

  toggleActiveClass = (e, callback) => {
    if (this.state.screenWidth < 1024) {
      const parentEl = e.currentTarget.parentNode;
      const elMainClass = parentEl.classList[0];

      if (typeof callback === "function") {
        callback(parentEl, elMainClass);
      }

      if (parentEl.classList) {
        parentEl.classList.toggle("active");
      } else {
        // For IE9
        var classes = parentEl.className.split(" ");
        var i = classes.indexOf("active");

        if (i >= 0) classes.splice(i, 1);
        else classes.push("active");
        parentEl.className = classes.join(" ");
      }
    }
  };

  handleCountrySelector = (e) => {
    const countries = [
      {
        code: "uk",
        name: "United Kingdom",
        flagImg: "/images/uk-flag.svg",
        phoneText: "+44 333 577 2373",
        phoneNo: "+44 333-577-2373",
      },
      {
        code: "us",
        name: "United States",
        flagImg: "/images/us-flag.svg",
        phoneText: "+1 888 766 5582",
        phoneNo: "+1 888 766 5582",
      },
    ];
    const selectedCode = e.currentTarget.getAttribute("data-country-code");
    const activeCountry = _.find(countries, (country) => {
      return country.code === selectedCode;
    });

    // this.hideDropdown();
    this.setState(
      {
        activeCountry: activeCountry,
      },
      () => {
        const endPath = this.handleEndPath();

        if (this.state.activeCountry.code === "uk") {
          this.props.history.push("/uk" + endPath);
        }
        if (this.state.activeCountry.code === "us") {
          this.props.history.push(endPath);
        }
      }
    );
  };

  handleEndPath = () => {
    const currentLocation = this.props.location.pathname;

    const pathArr = _.remove(currentLocation.split("/").splice(1), (path) => {
      return path !== "uk";
    });
    let endPath = "";

    _.map(pathArr, (path, index) => {
      endPath = endPath + "/" + path;
    });

    return endPath;
  };

  handleWFtraffic = () => {
    const language = window.navigator.userLanguage || window.navigator.language;
    const endPath = this.handleEndPath();

    if (
      language.toLowerCase() === "en-gb" &&
      window.location.pathname !== "/eu/privacy-policy"
    ) {
      this.props.history.push("/uk" + endPath + window.location.search);
    }
  };

  handleCatNavScrollLeft = () => {
    this.catNavUl.current.scrollBy({
      left: -150,
      behavior: "smooth",
    });
  };

  handleCatNavScrollRight = () => {
    this.catNavUl.current.scrollBy({
      left: 150,
      behavior: "smooth",
    });
  };

  handleCatNavs = () => {
    if (
      this.catNavUl.current.scrollWidth - this.catNavUl.current.clientWidth ===
      this.catNavUl.current.scrollLeft
    ) {
      this.rightScroll.current.style.opacity = 0.4;
    } else {
      this.rightScroll.current.style.opacity = 1;
    }
    if (this.catNavUl.current.scrollLeft === 0) {
      this.leftScroll.current.style.opacity = 0.4;
    } else {
      this.leftScroll.current.style.opacity = 1;
    }
  };

  hideDropdown = () => {
    this.setState(
      {
        navbarMenuHidden: true,
        hideDropdown: true,
      },
      this.resetDPState()
    );
  };

  resetDPState = () => {
    setTimeout(() => {
      this.setState({
        hideDropdown: false,
      });
    }, 300);
  };

  setIndustries = () => {
    const country = this.state.activeCountry.code
      ? this.state.activeCountry.code
      : "us";

    const countryPages = _.find(IndustriesSummaryForNav, (data) => {
      return data.country.code === country;
    });
    // console.log(countryPages.country.pages)
    this.setState({
      industries: countryPages.country.pages,
      isLoading: false,
    });
  };

  render() {
    return (
      <Fragment>
        <div
          className={
            `${
              this.state.isNews === true
                ? "navbar_main_nonfixed navbar__main"
                : "navbar__main"
            }` +
            " " +
            `${this.state.showCategories ? "bg-white" : ""} ${
              this.state.navIsScrolled
                ? "bg-white shadow-lg"
                : "bg-transparent shadow-none"
            }`
          }
        >
          <section className="navbar__top">
            <div className="max-w-6xl ml-auto mr-auto flex items-center justify-center h-12 lg:h-20">
              <nav
                className={cx([
                  "navbar__main",
                  "px-4",
                  "py-2",
                  "relative",
                  this.state.navbarMenuHidden ? "bg-transparent" : "bg-white",
                ])}
              >
                <section className="flex justify-between items-center">
                  <NavLink
                    to={this.state.activeCountry.code === "us" ? "/" : "/uk"}
                    className="navbar__brand -mt-1"
                  >
                    <OptimisedImage
                      src={
                        this.state.textWhite && this.state.navbarMenuHidden
                          ? wflogoWhite
                          : wflogo
                      }
                      alt="Workforce.com"
                    />
                  </NavLink>
                  <div className="flex lg:hidden justify-center">
                    <NavLink
                      to={
                        this.state.activeCountry.code === "us"
                          ? "/search"
                          : "/uk/search"
                      }
                      className="flex justify-center mr-4 xs:mr-6"
                    >
                      <i
                        className={cx([
                          "material-icons",
                          "text-md",
                          this.state.textWhite
                            ? "text-white"
                            : "text-blue-dark",
                        ])}
                      >
                        search
                      </i>
                    </NavLink>
                    <button
                      className="navbar__menu-btn block focus:outline-none relative"
                      onClick={this.toggleNavbarMenu}
                    >
                      {this.state.navbarMenuHidden ? (
                        <Fragment>
                          <span
                            className={
                              this.state.textWhite &&
                              this.state.navbarMenuHidden
                                ? "bg-white"
                                : "bg-blue-dark"
                            }
                          />
                          <span
                            className={
                              this.state.textWhite &&
                              this.state.navbarMenuHidden
                                ? "bg-white"
                                : "bg-blue-dark"
                            }
                          />
                          <span
                            className={
                              this.state.textWhite &&
                              this.state.navbarMenuHidden
                                ? "bg-white"
                                : "bg-blue-dark"
                            }
                          />
                        </Fragment>
                      ) : (
                        <Fragment>
                          <i className="material-icons">clear</i>
                        </Fragment>
                      )}
                    </button>
                  </div>
                  <ul
                    className={cx([
                      "absolute",
                      "bg-white",
                      "flex-col",
                      "lg:bg-transparent",
                      "lg:flex",
                      "lg:flex-row",
                      "lg:shadow-none",
                      "lg:static",
                      "lg:w-auto",
                      "navbar__menu",
                      "shadow-md",
                      "w-full",
                      this.state.navbarMenuHidden ? "hidden" : "flex",
                    ])}
                  >
                    <li
                      className={cx([
                        "border-b",
                        "border-gray-100",
                        "dropdown",
                        "group",
                        "lg:border-b-0",
                        "lg:mr-5",
                        "lg:px-0",
                        "lg:w-auto",
                        "navbar__item",
                        "px-3",
                        "relative",
                        "w-full",
                      ])}
                    >
                      <button
                        className={cx([
                          "dropdown__toggle",
                          "flex",
                          "flex-wrap",
                          "lg:py-0",
                          "lg:w-auto",
                          "navbar__link",
                          "py-3",
                          "w-full",
                          this.state.textWhite && this.state.navbarMenuHidden
                            ? "text-white"
                            : "text-blue-dark",
                        ])}
                        onClick={(e) =>
                          this.toggleActiveClass(e, this.removeActiveClass)
                        }
                      >
                        <div className="container flex items-center justify-between lg:justify-center w-full mx-auto text-xl lg:text-base lg:leading-none">
                          Product
                          <i className="fas fa-chevron-down nav-arrow"></i>
                        </div>
                      </button>
                      <ul
                        className={cx([
                          "bg-white",
                          "container",
                          "dropdown__menu",
                          "lg:absolute",
                          "lg:center-horizontal",
                          "lg:flex-row",
                          "lg:flex-wrap",
                          "lg:justify-between",
                          "lg:mb-0",
                          "lg:rounded",
                          "lg:shadow-lg",
                          "mb-3",
                          "overflow-hidden",
                          "static",
                          "z-10",
                          this.state.hideDropdown ? "hidden-i" : " ",
                        ])}
                      >
                        <li className="w-full">
                          <div className="flex flex-wrap sm:flex-no-wrap">
                            <ul className="w-full lg:flex lg:flex-col lg:w-3/5 lg:p-12">
                              <li
                                onClick={this.hideDropdown}
                                className="group__link"
                              >
                                <NavLink
                                  to={
                                    this.state.activeCountry.code === "us"
                                      ? "/software/scheduling-software"
                                      : "/uk/software/rota"
                                  }
                                >
                                  <OptimisedImage
                                    className="w-8 lg:w-12"
                                    alt=""
                                    src="/images/features/icons/scheduling-software.png"
                                  />
                                  <OptimisedImage
                                    className="w-8 lg:w-12"
                                    alt=""
                                    src="/images/features/icons/hover-scheduling-software.png"
                                  />
                                  <div className="px-4">
                                    <p className="text-blue-dark text-sm lg:text-base py-2 lg:py-0">
                                      <strong>Scheduling Software</strong>
                                    </p>
                                    <p className="text-gray-400 text-sm hidden lg:block">
                                      Build and send optimal schedules to staff
                                    </p>
                                  </div>
                                </NavLink>
                              </li>
                              <li
                                onClick={this.hideDropdown}
                                className="group__link"
                              >
                                <NavLink
                                  to={
                                    this.state.activeCountry.code === "us"
                                      ? "/software/time-and-attendance"
                                      : "/uk/software/time-and-attendance"
                                  }
                                >
                                  <OptimisedImage
                                    className="w-8 lg:w-12"
                                    alt=""
                                    src="/images/features/icons/time-and-attendance.png"
                                  />
                                  <OptimisedImage
                                    className="w-8 lg:w-12"
                                    alt=""
                                    src="/images/features/icons/hover-time-and-attendance.png"
                                  />
                                  <div className="px-4">
                                    <p className="text-blue-dark text-sm lg:text-base py-2 lg:py-0">
                                      <strong>Time and Attendance</strong>
                                    </p>
                                    <p className="text-gray-400 text-sm hidden lg:block">
                                      Accurately clock in and out of work
                                    </p>
                                  </div>
                                </NavLink>
                              </li>
                              <li
                                onClick={this.hideDropdown}
                                className="group__link"
                              >
                                <NavLink
                                  to={
                                    this.state.activeCountry.code === "us"
                                      ? "/software/employee-app"
                                      : "/uk/software/employee-app"
                                  }
                                >
                                  <OptimisedImage
                                    className="w-8 lg:w-12"
                                    alt=""
                                    src="/images/features/icons/employee-app.png"
                                  />
                                  <OptimisedImage
                                    className="w-8 lg:w-12"
                                    alt=""
                                    src="/images/features/icons/hover-employee-app.png"
                                  />
                                  <div className="px-4">
                                    <p className="text-blue-dark text-sm lg:text-base py-2 lg:py-0">
                                      <strong>Employee App</strong>
                                    </p>
                                    <p className="text-gray-400 text-sm hidden lg:block">
                                      #1 rated app for shifts & communication
                                    </p>
                                  </div>
                                </NavLink>
                              </li>
                              <li
                                onClick={this.hideDropdown}
                                className="group__link"
                              >
                                <NavLink
                                  to={
                                    this.state.activeCountry.code === "us"
                                      ? "/software/workforce-analytics"
                                      : "/uk/software/workforce-analytics"
                                  }
                                >
                                  <OptimisedImage
                                    className="w-8 lg:w-12"
                                    alt=""
                                    src="/images/features/icons/labor-analytics.png"
                                  />
                                  <OptimisedImage
                                    className="w-8 lg:w-12"
                                    alt=""
                                    src="/images/features/icons/hover-labor-analytics.png"
                                  />
                                  <div className="px-4 max-w-xs">
                                    <p className="text-blue-dark text-sm lg:text-base py-2 lg:py-0">
                                      <strong>Workforce Analytics</strong>
                                    </p>
                                    <p className="text-gray-400 text-sm hidden lg:block">
                                      Forecast wages, control{" "}
                                      {this.state.activeCountry.code === "us"
                                        ? "labor"
                                        : "labour"}{" "}
                                      cost and boost productivity
                                    </p>
                                  </div>
                                </NavLink>
                              </li>
                              {this.state.activeCountry.code === "us" ? (
                                <li
                                  onClick={this.hideDropdown}
                                  className="group__link"
                                >
                                  <NavLink
                                    to={
                                      this.state.activeCountry.code === "us"
                                        ? "/software/wage-and-hour-compliance"
                                        : "/uk/software/payroll-integration"
                                    }
                                  >
                                    <OptimisedImage
                                      className="w-8 lg:w-12"
                                      alt=""
                                      src="/images/features/icons/workforce-compliance.png"
                                    />
                                    <OptimisedImage
                                      className="w-8 lg:w-12"
                                      alt=""
                                      src="/images/features/icons/hover-workforce-compliance.png"
                                    />
                                    <div className="px-4 max-w-xs">
                                      <p className="text-blue-dark text-sm lg:text-base py-2 lg:py-0">
                                        {this.state.activeCountry.code ===
                                        "us" ? (
                                          <strong>
                                            Wage and Hour Compliance
                                          </strong>
                                        ) : (
                                          <strong>Labour Compliance</strong>
                                        )}
                                      </p>
                                      <p className="text-gray-400 text-sm hidden lg:block">
                                        Automate Federal, State, Local and Fair
                                        Work Week labor laws
                                      </p>
                                    </div>
                                  </NavLink>
                                </li>
                              ) : (
                                ""
                              )}
                              <li className="hidden lg:block">
                                <NavLink
                                  className="link link__blue link__arrow font-bold mt-4 ml-8 inline-block"
                                  to={
                                    this.state.activeCountry.code === "us"
                                      ? "/videos/watch/great-workforce-management-starts-here-id=0yt=0"
                                      : "/uk/videos/watch/great-workforce-management-starts-here-id=0yt=0"
                                  }
                                >
                                  30 second overview
                                </NavLink>
                              </li>
                            </ul>
                            <ul className="dropdown__list w-full lg:w-2/5 lg:bg-gray-100 lg:p-12 hidden lg:block">
                              <li onClick={this.hideDropdown}>
                                <NavLink
                                  className="text-sm lg:text-base inline-block my-1 lg:font-bold hover:text-blue-light"
                                  to={
                                    this.state.activeCountry.code === "us"
                                      ? "/software/timeclock-app"
                                      : "/uk/software/timeclock-app"
                                  }
                                >
                                  Time Clock App
                                </NavLink>
                              </li>
                              <li onClick={this.hideDropdown}>
                                <NavLink
                                  className="text-sm lg:text-base inline-block my-1 lg:font-bold hover:text-blue-light"
                                  to={
                                    this.state.activeCountry.code === "us"
                                      ? "/software/auto-scheduling"
                                      : "/uk/software/auto-scheduling"
                                  }
                                >
                                  Auto-Scheduling
                                </NavLink>
                              </li>
                              <li onClick={this.hideDropdown}>
                                <NavLink
                                  className="text-sm lg:text-base inline-block my-1 lg:font-bold hover:text-blue-light"
                                  to={
                                    this.state.activeCountry.code === "us"
                                      ? "/software/employee-onboarding"
                                      : "/uk/software/employee-onboarding"
                                  }
                                >
                                  Employee Onboarding
                                </NavLink>
                              </li>
                              <li onClick={this.hideDropdown}>
                                <NavLink
                                  className="text-sm lg:text-base inline-block my-1 lg:font-bold hover:text-blue-light"
                                  to={
                                    this.state.activeCountry.code === "us"
                                      ? "/software/chat"
                                      : "/uk/software/chat"
                                  }
                                >
                                  Workforce Chat
                                </NavLink>
                              </li>
                              <li onClick={this.hideDropdown}>
                                <NavLink
                                  className="text-sm lg:text-base inline-block my-1 lg:font-bold hover:text-blue-light"
                                  to={
                                    this.state.activeCountry.code === "us"
                                      ? "/software/leave-and-unavailability"
                                      : "/uk/software/leave-and-unavailability"
                                  }
                                >
                                  Time-Off
                                </NavLink>
                              </li>
                              <li>
                                <NavLink
                                  className="text-sm lg:text-base inline-block my-1 lg:font-bold hover:text-blue-light"
                                  to={
                                    this.state.activeCountry.code === "us"
                                      ? "/software/livewage-tracker"
                                      : "/uk/software/livewage-tracker"
                                  }
                                >
                                  Live Wage Tracker
                                </NavLink>
                              </li>
                              <li>
                                <NavLink
                                  className="text-sm lg:text-base inline-block my-1 lg:font-bold hover:text-blue-light"
                                  to={
                                    this.state.activeCountry.code === "us"
                                      ? "/software/live-insights"
                                      : "/uk/software/live-insights"
                                  }
                                >
                                  Live Insights
                                </NavLink>
                              </li>
                              <li onClick={this.hideDropdown}>
                                <NavLink
                                  className="text-sm lg:text-base inline-block my-1 lg:font-bold hover:text-blue-light"
                                  to={
                                    this.state.activeCountry.code === "us"
                                      ? "/software/shift-swapping"
                                      : "/uk/software/shift-swapping"
                                  }
                                >
                                  Shift Swapping
                                </NavLink>
                              </li>
                              <li onClick={this.hideDropdown}>
                                <NavLink
                                  className="text-sm lg:text-base inline-block my-1 lg:font-bold hover:text-blue-light"
                                  to={
                                    this.state.activeCountry.code === "us"
                                      ? "/software/shift-feedback"
                                      : "/uk/software/shift-feedback"
                                  }
                                >
                                  Shift Feedback
                                </NavLink>
                              </li>
                              <li onClick={this.hideDropdown}>
                                <NavLink
                                  className="text-sm lg:text-base inline-block my-1 lg:font-bold hover:text-blue-light"
                                  to={
                                    this.state.activeCountry.code === "us"
                                      ? "/software/shift-feedback"
                                      : "/uk/software/shift-feedback"
                                  }
                                >
                                  Shift Ratings
                                </NavLink>
                              </li>
                              <li onClick={this.hideDropdown}>
                                <NavLink
                                  className="text-sm lg:text-base inline-block my-1 lg:font-bold hover:text-blue-light"
                                  to={
                                    this.state.activeCountry.code === "us"
                                      ? "/software/payroll-integration"
                                      : "/uk/software/payroll-integration"
                                  }
                                >
                                  Payroll Integration
                                </NavLink>
                              </li>
                            </ul>
                          </div>
                        </li>
                      </ul>
                    </li>
                    <li className="navbar__item w-full lg:w-auto lg:mr-5 dropdown relative group border-b border-gray-100 lg:border-b-0 px-3 lg:px-0">
                      <button
                        className={cx([
                          "dropdown__toggle",
                          "flex",
                          "flex-wrap",
                          "lg:py-0",
                          "lg:w-auto",
                          "navbar__link",
                          "py-3",
                          "w-full",
                          this.state.textWhite && this.state.navbarMenuHidden
                            ? "text-white"
                            : "text-blue-dark",
                        ])}
                        onClick={(e) =>
                          this.toggleActiveClass(e, this.removeActiveClass)
                        }
                      >
                        <div className="container flex items-center justify-between lg:justify-center w-full mx-auto">
                          <p className="text-xl lg:text-base lg:leading-none">
                            Use Cases
                          </p>
                          <i className="fas fa-chevron-down nav-arrow"></i>
                        </div>
                      </button>
                      <ul
                        className={cx([
                          "bg-white",
                          "container",
                          "dropdown__menu",
                          "lg:absolute",
                          "lg:center-horizontal",
                          "lg:flex-row",
                          "lg:flex-wrap",
                          "lg:justify-between",
                          "lg:mb-0",
                          "lg:rounded",
                          "lg:shadow-lg",
                          "mb-3",
                          "overflow-hidden",
                          "static",
                          "z-10",
                          this.state.hideDropdown ? "hidden-i" : " ",
                        ])}
                      >
                        <li className="w-full">
                          <ul className="flex flex-wrap sm:flex-no-wrap">
                            <div className="w-full lg:flex lg:flex-col lg:w-2/5 lg:p-12">
                              <li className="dropdown__list w-full mr-0 border-0 lg:mb-4 sm:mb-0 active">
                                <p
                                  className="font-bold text-gray-300 pb-2 lg:pb-5 pt-2 lg:pt-0 flex items-center justify-between list__title"
                                  onClick={(e) =>
                                    this.toggleActiveClass(
                                      e,
                                      this.removeActiveClass
                                    )
                                  }
                                >
                                  BY ROLE
                                </p>
                                <ul className="hidden sm:flex flex-wrap">
                                  {_.map(
                                    RolesSummaryForNav[0].country.pages,
                                    (role, index) => {
                                      return (
                                        <li
                                          onClick={this.hideDropdown}
                                          className="text-blue-dark leading-snug mb-0 lg:mb-4 w-full lg:w-1/2"
                                          key={index}
                                        >
                                          <NavLink
                                            to={
                                              this.state.activeCountry.code ===
                                              "us"
                                                ? "/role/" + role.slug
                                                : "/uk/role/" + role.slug
                                            }
                                            className="hover:text-blue-light py-2 lg:py-0 block text-sm lg:text-base"
                                            key={index}
                                          >
                                            {role.title}
                                          </NavLink>
                                        </li>
                                      );
                                    }
                                  )}
                                </ul>
                              </li>
                            </div>

                            <li className="dropdown__list w-full lg:w-3/5 lg:bg-gray-100 lg:p-12">
                              <p
                                className="font-bold text-gray-300 pb-2 lg:pb-5 pt-2 lg:pt-0 flex items-center justify-between list__title"
                                onClick={(e) =>
                                  this.toggleActiveClass(
                                    e,
                                    this.removeActiveClass
                                  )
                                }
                              >
                                BY INDUSTRY
                              </p>
                              <ul className="hidden sm:flex flex-wrap">
                                {_.map(
                                  this.state.industries,
                                  (industry, index) => (
                                    <li
                                      onClick={this.hideDropdown}
                                      className="text-blue-dark leading-snug mb-0 lg:mb-8 w-full lg:w-1/3 pr-4"
                                      key={index}
                                    >
                                      <NavLink
                                        to={
                                          this.state.activeCountry.code === "us"
                                            ? "/industry/" + industry.slug
                                            : "/uk/industry/" + industry.slug
                                        }
                                        className="hover:text-blue-light py-2 lg:py-0 block text-sm lg:text-base"
                                        key={index}
                                      >
                                        {industry.title}
                                      </NavLink>
                                    </li>
                                  )
                                )}
                              </ul>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                    <li className="navbar__item w-full lg:w-auto lg:mr-5 dropdown relative group border-b border-gray-100 lg:border-b-0 px-3 lg:px-0">
                      <button
                        className={cx([
                          "dropdown__toggle",
                          "flex",
                          "flex-wrap",
                          "lg:py-0",
                          "lg:w-auto",
                          "navbar__link",
                          "py-3",
                          "w-full",
                          this.state.textWhite && this.state.navbarMenuHidden
                            ? "text-white"
                            : "text-blue-dark",
                        ])}
                        onClick={(e) =>
                          this.toggleActiveClass(e, this.removeActiveClass)
                        }
                      >
                        <div className="container flex items-center justify-between lg:justify-center w-full mx-auto">
                          <a
                            href={
                              this.state.activeCountry.code === "us"
                                ? "/news"
                                : "/uk/news"
                            }
                            className="text-xl lg:text-base lg:leading-none"
                          >
                            News
                          </a>
                        </div>
                      </button>
                    </li>
                    <li className="navbar__item w-full lg:w-auto lg:mr-5 dropdown relative group border-b border-gray-100 lg:border-b-0 px-3 lg:px-0">
                      <button
                        className={cx([
                          "dropdown__toggle",
                          "flex",
                          "flex-wrap",
                          "lg:py-0",
                          "lg:w-auto",
                          "navbar__link",
                          "py-3",
                          "w-full",
                          this.state.textWhite && this.state.navbarMenuHidden
                            ? "text-white"
                            : "text-blue-dark",
                        ])}
                        onClick={(e) =>
                          this.toggleActiveClass(e, this.removeActiveClass)
                        }
                      >
                        <div className="container flex items-center justify-between lg:justify-center w-full mx-auto">
                          <p className="text-xl lg:text-base lg:leading-none">
                            Resources
                          </p>
                          <i className="fas fa-chevron-down nav-arrow"></i>
                        </div>
                      </button>
                      <ul
                        className={cx([
                          "bg-white",
                          "container",
                          "dropdown__menu",
                          "lg:absolute",
                          "lg:center-horizontal",
                          "lg:flex-row",
                          "lg:flex-wrap",
                          "lg:justify-between",
                          "lg:mb-0",
                          "lg:p-12",
                          "lg:rounded",
                          "lg:shadow-lg",
                          "mb-3",
                          "static",
                          "z-10",
                          this.state.hideDropdown ? "hidden-i" : "",
                        ])}
                      >
                        <li className="dropdown__list w-full">
                          <ul className="flex flex-wrap">
                            <li
                              onClick={this.hideDropdown}
                              className="text-blue-dark leading-snug mb:0 lg:mb-2 w-1/2"
                            >
                              <NavLink
                                to={
                                  this.state.activeCountry.code === "us"
                                    ? "/videos"
                                    : "/uk/videos"
                                }
                                className={
                                  "hover:text-blue-light block py-2 lg:py-0 text-sm lg:text-base"
                                }
                              >
                                Videos
                              </NavLink>
                            </li>
                            <li
                              onClick={this.hideDropdown}
                              className="text-blue-dark leading-snug mb:0 lg:mb-2 w-1/2"
                            >
                              <NavLink
                                to={
                                  this.state.activeCountry.code === "us"
                                    ? "/contact-us"
                                    : "/uk/contact-us"
                                }
                                className="hover:text-blue-light block py-2 lg:py-0 text-sm lg:text-base"
                              >
                                Contact Us
                              </NavLink>
                            </li>
                            <li
                              onClick={this.hideDropdown}
                              className="text-blue-dark leading-snug mb:0 lg:mb-2 w-1/2"
                            >
                              <NavLink
                                to={
                                  this.state.activeCountry.code === "us"
                                    ? "/integrations"
                                    : "/uk/integrations"
                                }
                                className="hover:text-blue-light block py-2 lg:py-0 text-sm lg:text-base"
                              >
                                Integrations
                              </NavLink>
                            </li>
                            <li
                              onClick={this.hideDropdown}
                              className="text-blue-dark leading-snug mb:0 lg:mb-2 w-1/2"
                            >
                              <a
                                href="https://my.tanda.co/api/v2/documentation"
                                target="_blank"
                                rel="noopener noreferrer"
                                className={
                                  "hover:text-blue-light block py-2 lg:py-0 text-sm lg:text-base"
                                }
                              >
                                API
                              </a>
                            </li>
                            <li
                              onClick={this.hideDropdown}
                              className="text-blue-dark leading-snug mb:0 lg:mb-2 w-1/2"
                            >
                              <NavLink
                                to={
                                  this.state.activeCountry.code === "us"
                                    ? "/wf-events/"
                                    : "/uk/wf-events/"
                                }
                                className={
                                  "hover:text-blue-light block py-2 lg:py-0 text-sm lg:text-base"
                                }
                              >
                                Webinars
                              </NavLink>
                            </li>
                            <li
                              onClick={this.hideDropdown}
                              className="text-blue-dark leading-snug mb:0 lg:mb-2 w-1/2"
                            >
                              <NavLink
                                to={
                                  this.state.activeCountry.code === "us"
                                    ? "/whitepapers"
                                    : "/uk/whitepapers"
                                }
                                className={
                                  "hover:text-blue-light block py-2 lg:py-0 text-sm lg:text-base"
                                }
                              >
                                Whitepapers
                              </NavLink>
                            </li>
                            <li
                              onClick={this.hideDropdown}
                              className="text-blue-dark leading-snug mb:0 lg:mb-2 w-1/2"
                            >
                              <a
                                href={`${
                                  this.state.activeCountry.code === "uk"
                                    ? "/uk"
                                    : ""
                                }/news/workforce-management-rfp-template`}
                                className="hover:text-blue-light block py-2 lg:py-0 text-sm lg:text-base"
                              >
                                Free RFP Template
                              </a>
                            </li>
                            <li
                              onClick={this.hideDropdown}
                              className="text-blue-dark leading-snug mb:0 lg:mb-2 w-1/2"
                            >
                              <a
                                href="https://help.tanda.co/en/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className={
                                  "hover:text-blue-light block py-2 lg:py-0 text-sm lg:text-base"
                                }
                              >
                                Help
                              </a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                    <li
                      className={cx([
                        "border-b",
                        "border-gray-100",
                        "lg:border-b-0",
                        "lg:mr-5",
                        "lg:w-auto",
                        "navbar__item",
                        "w-full",
                        this.state.textWhite && this.state.navbarMenuHidden
                          ? "text-white"
                          : "text-blue-dark",
                      ])}
                    >
                      <NavLink
                        to={
                          this.state.activeCountry.code === "us"
                            ? "/pricing"
                            : "/uk/pricing"
                        }
                      >
                        <button
                          onClick={this.hideDropdown}
                          className={cx([
                            "flex",
                            "flex-wrap",
                            "lg:p-0",
                            "lg:w-auto",
                            "navbar__link",
                            "p-3",
                            "w-full",
                            this.state.textWhite && this.state.navbarMenuHidden
                              ? "text-white"
                              : "text-blue-dark",
                          ])}
                        >
                          <div className="container flex items-center justify-between lg:justify-center w-full mx-auto">
                            <p className="text-xl lg:text-base lg:leading-none">
                              Pricing
                            </p>
                          </div>
                        </button>
                      </NavLink>
                    </li>
                    <li
                      className={cx([
                        "border-b",
                        "border-gray-100",
                        "lg:border-b-0",
                        "lg:mr-5",
                        "lg:w-auto",
                        "navbar__item",
                        "w-full",
                        this.state.textWhite && this.state.navbarMenuHidden
                          ? "text-white"
                          : "text-blue-dark",
                      ])}
                    >
                      <NavLink
                        to={
                          this.state.activeCountry.code === "us"
                            ? "/about"
                            : "/uk/about"
                        }
                      >
                        <button
                          onClick={this.hideDropdown}
                          className={cx([
                            "navbar__link",
                            "flex",
                            "flex-wrap",
                            "w-full",
                            "lg:w-auto",
                            "p-3",
                            "lg:p-0",
                            this.state.textWhite && this.state.navbarMenuHidden
                              ? "text-white"
                              : "text-blue-dark",
                          ])}
                        >
                          <div className="container flex items-center justify-between lg:justify-center w-full mx-auto">
                            <p className="text-xl lg:text-base lg:leading-none">
                              About Us
                            </p>
                          </div>
                        </button>
                      </NavLink>
                    </li>
                    <div className="lg:hidden flex flex-row items-center justify-center w-full p-2">
                      <SignUpBtn
                        country={this.state.activeCountry.code}
                        action="email"
                      ></SignUpBtn>

                      <a
                        name="tanda"
                        href="https://my.workforce.com/login"
                        rel="noopener noreferrer"
                        className={cx([
                          "hover:text-blue-light",
                          "ml-6",
                          "mr-6",
                          this.state.textWhite && this.state.navbarMenuHidden
                            ? "text-white"
                            : "text-blue-dark",
                        ])}
                      >
                        Login
                      </a>
                      <li>
                        <NavLink
                          onClick={this.handleRemoveCountryCode}
                          to="/us"
                        >
                          <img
                            className="w-4 ml-4"
                            src="https://www.workforce.com/images/logos/US.png"
                            alt="US"
                          />
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/uk">
                          <img
                            className="w-4 ml-4"
                            src="https://www.workforce.com/images/logos/UK.png"
                            alt="UK"
                          />
                        </NavLink>
                      </li>
                    </div>
                  </ul>
                  <ul
                    className={`absolute bg-white flex-col lg:bg-transparent lg:flex lg:flex-row lg:static lg:w-auto navbar__menu w-full ${
                      this.state.navbarMenuHidden ? "hidden" : "flex"
                    }`}
                  >
                    <li className="navbar__item w-full lg:w-auto ">
                      <NavLink
                        to={
                          this.state.activeCountry.code === "us"
                            ? "/search"
                            : "/uk/search"
                        }
                        className="hidden lg:flex justify-center"
                      >
                        <i
                          className={cx([
                            "material-icons",
                            "text-md",
                            this.state.textWhite
                              ? "text-white"
                              : "text-blue-dark",
                          ])}
                        >
                          search
                        </i>
                      </NavLink>
                    </li>
                    <li className="hello navbar__item w-full lg:w-auto lg:block hidden ml-6">
                      <SignUpBtn
                        country={this.state.activeCountry.code}
                        action="email"
                      ></SignUpBtn>
                    </li>
                    <li className="navbar__item w-full lg:w-auto lg:block hidden">
                      <a
                        name="tanda"
                        href="https://my.workforce.com/login"
                        rel="noopener noreferrer"
                        className={cx([
                          "hover:text-blue-light",
                          "ml-4",
                          this.state.textWhite && this.state.navbarMenuHidden
                            ? "text-white"
                            : "text-blue-dark",
                        ])}
                      >
                        Login
                      </a>
                    </li>
                    <li>
                      <NavLink to="/us" onClick={this.handleRemoveCountryCode}>
                        <img
                          className=" navbar__item w-4 lg:w-4 ml-4 lg:block hidden "
                          src="https://www.workforce.com/images/logos/US.png"
                          alt="US"
                        />
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/uk">
                        <img
                          className="navbar__item w-4 lg:w-4 ml-2 lg:block hidden "
                          src="https://www.workforce.com/images/logos/UK.png"
                          alt="UK"
                        />
                      </NavLink>
                    </li>
                  </ul>
                </section>
              </nav>
            </div>
          </section>
          {this.state.showCategories && (
            <div ref={this.scrollableNav} id="catNav" className="bg-gray-100">
              <div className="container flex flex-wrap items-center justify-center">
                <div className="xl:hidden cat-scroller-col w-1/12 inline-flex justify-end max-w-full">
                  <button
                    className="py-3 px-2 xs:px-5 mr-2 text-gray-500"
                    type="button"
                    ref={this.leftScroll}
                    onClick={this.handleCatNavScrollLeft}
                  >
                    &lt;
                  </button>
                </div>

                <section
                  className="text-center py-2 flex overflow-x-auto overflow-y-hidden w-10/12 xl:w-full cat-nav"
                  ref={this.catNavUl}
                  onScroll={this.handleCatNavs}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <NavLink
                    to={
                      this.state.activeCountry.code === "us"
                        ? "/news"
                        : "/uk/news"
                    }
                    className="text-gray-300 hover:text-blue-dark py-2 px-3 mx-3 whitespace-no-wrap"
                  >
                    News
                  </NavLink>
                  <a
                    href="https://magazine.workforce.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-blue-dark py-2 px-3 mx-3 whitespace-no-wrap"
                  >
                    Magazine
                  </a>
                  <NavLink
                    to={
                      this.state.activeCountry.code === "us"
                        ? "/whitepapers"
                        : "/uk/whitepapers"
                    }
                    className="text-gray-300 hover:text-blue-dark py-2 px-3 mx-3 whitespace-no-wrap"
                  >
                    Whitepapers
                  </NavLink>
                  <NavLink
                    to={
                      this.state.activeCountry.code === "us"
                        ? "/wf-events/"
                        : "/uk/wf-events/"
                    }
                    className="text-gray-300 hover:text-blue-dark py-2 px-3 mx-3 whitespace-no-wrap"
                  >
                    Webinars
                  </NavLink>
                  <NavLink
                    to={
                      this.state.activeCountry.code === "us"
                        ? "/wf-events"
                        : "/uk/wf-events"
                    }
                    className="text-gray-300 hover:text-blue-dark py-2 px-3 mx-3 whitespace-no-wrap"
                  >
                    Events
                  </NavLink>
                  <NavLink
                    to={
                      this.state.activeCountry.code === "us"
                        ? "/research"
                        : "/uk/research"
                    }
                    className="text-gray-300 hover:text-blue-dark py-2 px-3 mx-3 whitespace-no-wrap"
                  >
                    Research
                  </NavLink>
                  {/* <a
                    href="https://request.workforce.com/workforce-campaign-builder"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-300 hover:text-blue-dark py-2 px-3 mx-3 whitespace-no-wrap"
                  >
                    Advertise
                  </a> */}
                  <NavLink
                    to={
                      this.state.activeCountry.code === "us"
                        ? "/videos"
                        : "/uk/videos"
                    }
                    className="text-gray-300 hover:text-blue-dark py-2 px-3 mx-3 whitespace-no-wrap"
                  >
                    Videos
                  </NavLink>
                  <NavLink
                    to={
                      this.state.activeCountry.code === "us"
                        ? "/awards"
                        : "/uk/awards"
                    }
                    className="text-gray-300 hover:text-blue-dark py-2 px-3 mx-3 whitespace-no-wrap"
                  >
                    Awards
                  </NavLink>
                  {this.state.activeCountry.code === "us" && (
                    <NavLink
                      to="/subscribe"
                      className="text-gray-300 hover:text-blue-dark py-2 px-3 mx-3 whitespace-no-wrap"
                    >
                      Newsletter
                    </NavLink>
                  )}
                </section>

                <div className="xl:hidden cat-scroller-col w-1/12">
                  <button
                    className="py-3 px-2 max-w-full md:ml-2 text-gray-500 w-full"
                    type="button"
                    ref={this.rightScroll}
                    onClick={this.handleCatNavScrollRight}
                  >
                    &gt;
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        {this.state.showBanner && (
          <section className="news__banner bg-blue-dark text-center flex flex-col sm:flex-row items-center justify-center h-20 lg:h-16">
            <p className="leading-none text-white sm:text-lg mr-1">
              &quot;Without Workforce.com, we wouldn&apos;t have been able to
              run our vaccine sites.&quot;
            </p>
            <NavLink
              to={
                this.state.activeCountry.code === "us"
                  ? "/videos/watch/covidcheck-colorado--workforcecom-id=4yt=1"
                  : "/uk/videos/watch/covidcheck-colorado--workforcecom-id=4yt=1"
              }
              className="mt-2 sm:mt-0 link link__blue link__arrow leading-none sm:text-lg text-blue-legacy"
            >
              Watch How
            </NavLink>
          </section>
        )}
      </Fragment>
    );
  }
}
export default withRouter(Navbar);
